import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_BAGGAGE_DELAY_STATE,
  RESET_BAGGAGE_BEEN_RETUNRED_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    whatHappenedToYourBaggageAndPersonalItems: [],
    hasYourBaggageBeenReturnedToYou: 'false',
    dateWhenYourLuggageWasReturned: '',
    infoBaggageDelayItems: [],

    whatItemsAreYouClaimingFor: [],
    infoEssentialMedicationItems: [],
    infoJewelleryOrTraditionalWatchesItems: [],
    infoLaptopsTabletsOrCamerasItems: [],
    infoOtherUnspecifiedItems: [],
    infoSpecifiedHighValueItems: [],
    infoBankCardsOrTravelDocumentsItems: [],
    infoCashItems: [],
  },
  errors: [],
});

const initialBaggageDelay = {
  form: {
    hasYourBaggageBeenReturnedToYou: 'false',
    dateWhenYourLuggageWasReturned: '',
    infoBaggageDelayItems: [],
  },
};

const initialBaggageBeenReturned = {
  form: {
    dateWhenYourLuggageWasReturned: '',
  },
};

function baggageAndPersonalItemsSCTIStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_BAGGAGE_DELAY_STATE:
      return state
        .setIn(['form', 'infoBaggageDelayItems'], [])
        .mergeDeep(initialBaggageDelay);
    case RESET_BAGGAGE_BEEN_RETUNRED_STATE:
      return state
        .mergeDeep(initialBaggageBeenReturned);
    default:
      return state;
  }
}

export default baggageAndPersonalItemsSCTIStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.BaggageAndPersonalItems/reducer.js